import { BehaviorSubject } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';

/**
 * @constructor
 */
export class SystemStatusService {
  /**
   * @private
   * @type {BehaviorSubject<SystemStatus[keyof SystemStatus]>}
   */
  _subject = new BehaviorSubject(SystemStatus.Initializing);

  status$ = this._subject.pipe(distinctUntilChanged());

  components = {};

  constructor() {
  }

  /**
   * @param {string} componentName
   */
  addComponent(componentName) {
    this.components[componentName] = SystemStatus.Initializing;

    this.updateSystemStatus();
  }

  /**
   * @param {string} componentName
   * @param {'offline' | 'online'} status
   */
  setComponentStatus(componentName, status) {
    console.log("setComponentStatus: ", componentName, status);
    this.components[componentName] = status;
    this.updateSystemStatus();
  }

  updateSystemStatus() {
    const keys = Object.keys(this.components);
    if (keys.length <= 0) return;

    for (var i = 0; i <= keys.length; i++) {
      switch (this.components[keys[i]]) {
        case SystemStatus.Offline:
          this.setSystemStatusToOffline();
          return;
        case SystemStatus.Initializing:
          this.setSystemStatusToInitializing();
          return;
      }
    }

    // All are ready
    this.setSystemStatusToOnline();
  }

  setSystemStatusToInitializing() {
    this._subject.next(SystemStatus.Initializing);
  }

  setSystemStatusToOnline() {
    this._subject.next(SystemStatus.Online);
  }

  setSystemStatusToOffline() {
    this._subject.next(SystemStatus.Offline);
  }
}

/**
 * @type {{ Initializing: 'initializing'; Offline: 'offline'; Online: 'online'; }}
 */
export const SystemStatus = {
  Initializing: 'initializing',
  Offline: 'offline',
  Online: 'online'
};

export const moduleName = 'systemStatus';
export default {
  moduleName,
};

angular
  .module('systemStatus', [])
  .service('SystemStatusService', SystemStatusService);
